import { ProductApplication } from '../types/ProductApplication';
import { GetProductApplicationSegmentListingSchema } from '../schemas/ProductApplicationSegmentZodSchema';
import { ProductApplicationSegmentHubspotMappingForYageoContactUs } from '../types/productApplicationSegmentHubspotMapping';
import { ApplicationSegmentSchema } from '../schemas/ProductApplicationSegmentZodSchema';
import { z } from 'zod';

function makeYageoContactUsMapping(
    applicationSegment: z.infer<typeof ApplicationSegmentSchema>
): ProductApplicationSegmentHubspotMappingForYageoContactUs {
    return applicationSegment.hubspotYageoContactUs_enabled
        ? {
              enabled: true as const,
              fieldValue: applicationSegment.hubspotYageoContactUs_fieldValue!,
          }
        : {
              enabled: false as const,
              fieldValue: applicationSegment.hubspotYageoContactUs_fieldValue ?? null,
          };
}

/**
 * Transforms and validates the response from the getProductApplicationSegmentListing GraphQL query
 * to a simplified ProductApplication type.
 *
 * @param data The response data from the getProductApplicationSegmentListing query
 * @returns An array of valid ProductApplication objects
 */
export function transformProductApplicationSegmentResponse(
    data?: unknown // GetProductApplicationSegmentListingQuery  - use unknown for jest tests be
    // able to pass invalid data
): ProductApplication[] {
    // Parse and validate the data using the Zod schema
    const parsedResult = GetProductApplicationSegmentListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error(
            'Validation failed for getProductApplicationSegmentListing:',
            parsedResult.error.errors
        );
        return [];
    }

    const parsedSegments = parsedResult.data.getObjectFolder.children;

    // Transform segments to simplified ProductApplication type
    const applications: ProductApplication[] = [];
    parsedSegments.forEach((parsedSegment) => {
        const application: ProductApplication = {
            id: parsedSegment.id,
            key: parsedSegment.key,
            name: parsedSegment.name,
            children: [],
            hubspot: {
                yageoContactUs: makeYageoContactUsMapping(parsedSegment),
            },
        };
        application.children = parsedSegment.applications.map((parsedApplication) => {
            return {
                id: parsedApplication.id,
                key: parsedApplication.key,
                name: parsedApplication.name,
                parent: application,
            };
        });
        applications.push(application);
    });

    return applications;
}
